module.exports = __webpack_public_path__ + "static/day3-ca129044d7876701adb6e1ba973a4255.webm";